import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'underscore',
})
export class UnderscorePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    if (typeof value !== "string") return "";
    return value.replaceAll("_", " ");
  }

}
